import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import * as moment from 'moment';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
	selector: 'app-activity-table',
	templateUrl: './activity-table.component.html',
	styleUrls: ['./activity-table.component.scss']
})
export class ActivityTableComponent implements OnInit {

	@Input() activities_table_header: any;
	@Input() activities_table_data: any;
	@Input() view_type: any;
	@Input() activity_user_data: any;
	@Input() activity_action_type: any;
	@Input() selected_activity_type: any;

	@Input() selected_activity_type_id: any;

	@Input() stepper_stage: any;

	@Input() coaching_plan: any;

	@Output() activityDetailsUpdated = new EventEmitter<any>();

	user_details: any;
	user_role: any;

	constructor(
		public commonService: CommonService,
		private storageService: StorageService,
		private dialog: MatDialog,
		private router: Router,
		private route: ActivatedRoute,
	) { }

	ngOnInit(): void {
		this.user_details = this.storageService.get("user_details");
		if (this.user_details.role.role == 4) {
			this.user_role = "Advisor Manager";
		} else if (this.user_details.role.role == 5) {
			this.user_role = "Advisor";
		} else if (this.user_details.role.role == 6) {
			this.user_role = "AFA";
		} else if (this.user_details.role.role == 7) {
			this.user_role = "Assistant";
		} else if (this.user_details.role.role == 8) {
			this.user_role = "Relationship Manager";
		} else if (this.user_details.role.role == 11) {
			this.user_role = "Marketing Team";
			this.getAdvisors();
		} else if (this.user_details.role.role == 13) {
			this.user_role = "Lending Officer";
		} else if (this.user_details.role.role == 14) {
			this.user_role = "Insurance Agent";
		}
	}

	getKey(data, column) {
		const key = column['key'];
		if (data[key] && data[key] != "" && data[key] != null) {
			return data[key];
		} else {
			return "-";
		}

	}

	advisor_list: any = [];
	getAdvisors() {
		this.commonService.getData("/mtadvisorslist/").subscribe(
			(res: any) => {
				this.advisor_list = res["data"];
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	assignAdvisor(activity) {
		if (activity.assign_advisor != "") {
			const payload = {
				advisor_id: activity.assign_advisor,
				prospects: [activity.prospect_id]
			};
			this.commonService.postData("/mtassignprospect/", payload).subscribe(
				(res: any) => {
					this.activityDetailsUpdated.emit();
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		}
	}

	show_sub_tasks: number = null;
	toggleTasksView(value) {
		if (this.show_sub_tasks == value) {
			this.show_sub_tasks = null;
			this.sub_tasks_data = [];
		} else {
			this.show_sub_tasks = value;
			this.getSubTasksData();
		}
	}

	sub_tasks_data: any = [];
	sub_tasks_data_loaded: boolean = false;
	getSubTasksData() {
		this.sub_tasks_data_loaded = false;
		let route: any = "";

		const activity = this.activities_table_data[this.show_sub_tasks];

		if(this.user_role == "Advisor Manager") {
			route = "/advisormanageractivity/?advisor_manager=" + this.user_details.id + "&advisor=" + activity.advisor + "&parent_activity=" + activity.id + "&no_page=true&sub_task=true";

			if (this.coaching_plan) {
				route = route + "&coaching_plan=" + this.coaching_plan.id;
			}
		} else {
			if (activity.user_type == "Client") {
				route = "/clientsalesactivity?parent_activity=" + activity.id + "&advisor=" + activity.advisor + "&sub_task=true&no_page=true";
			} else if (activity.user_type == "Prospect") {
				route = "/leadprospectactivity?parent_activity=" + activity.id + "&advisor=" + activity.advisor + "&sub_task=true&no_page=true";
			}
		}

		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.sub_tasks_data = res;

				this.sub_tasks_data_loaded = true;
			},
			(err) => {
				this.sub_tasks_data = [];
				this.sub_tasks_data_loaded = true;
				this.commonService.showToast('error', err.error);
			},
		);
	}

	show_add_sub_task_view: boolean = false;
	addSubTask() {
		this.show_add_sub_task_view = true;
	}

	cancelSubTask() {
		this.show_add_sub_task_view = false;
		this.sub_task_name = "";
	}

	sub_task_name: any = "";
	save_sub_task_loader: boolean = false;
	saveSubTask() {
		if (this.sub_task_name != "" && this.sub_task_name != null) {
			this.save_sub_task_loader = true;
			let route: any = "/addsubtask/";

			const activity = this.activities_table_data[this.show_sub_tasks];

			let payload: any = {
				name: this.sub_task_name,
				parent_activity: activity.id,
				advisor: activity.advisor,
				activity_type: activity.activity_type,
				source: activity.source,

				status: 1,
				scheduled_date: moment(new Date()).format(),
				communication_type: 8,
			};

			if (activity.user_type == "Client") {
				payload.client = activity.client;
			} else if (activity.user_type == "Prospect") {
				payload.prospect = activity.prospect_id;
			}

			this.commonService.postData(route, payload).subscribe(
				(res: any) => {
					this.getSubTasksData();
					// this.sub_tasks_data.push(res);
					this.cancelSubTask();
					this.save_sub_task_loader = false;
				},
				(err) => {
					this.commonService.showToast('error', err.error);
					this.save_sub_task_loader = false;
				},
			);
		}
	}

	show_add_task_view: boolean = false;
	addTask() {
		this.show_add_task_view = true;
	}

	cancelTask() {
		this.show_add_task_view = false;
		this.task_name = "";
	}

	task_name: any = "";
	save_task_loader: boolean = false;
	saveTask() {
		if (this.task_name != "" && this.task_name != null) {
			this.save_task_loader = true;
			let route: any = "";

			const activity = this.activities_table_data[this.show_sub_tasks];

			let payload: any = {
				name: this.task_name,
				activity_type: this.selected_activity_type,

				status: 1,
				scheduled_date: moment(new Date()).format(),
				communication_type: 8,
			};

			if ('is_client' in this.activity_user_data) {
				route = "/leadprospectactivity/";
				payload.prospect = this.activity_user_data.id;
				payload.advisor = this.user_details.id;
			} else {
				route = "/clientsalesactivity/";
				payload.client = this.activity_user_data.id;
				payload.advisor = this.user_details.id;
			}

			this.commonService.postData(route, payload).subscribe(
				(res: any) => {
					this.activities_table_data.push(res);
					this.cancelTask();
					this.save_task_loader = false;
				},
				(err) => {
					this.commonService.showToast('error', err.error);
					this.save_task_loader = false;
				},
			);
		}
	}



	show_activity_details: boolean = false;
    show_activity_data: any;
    // showActivityDetails(data) {
	// 	this.show_activity_data = JSON.parse(JSON.stringify(data));
	// 	this.show_activity_details = true;
    // }

	show_ai_activity_data: boolean = false;
	ai_activity_data: any;

	selected_activities_list: any = [];
	showActivityDetails(data) {
		if (data.source == "wa" && data.activity_type == 3) {
			this.ai_activity_data = data;
			this.show_ai_activity_data = true;
		} else if (data.source == "wa" && data.activity_type == 4) {
			this.ai_activity_data = data;
			this.show_ai_activity_data = true;
		} else if (data.source == "wa" && data.activity_type == 5) {
			this.ai_activity_data = data;
			this.show_ai_activity_data = true;
		} else if (data.source == "ra" && data.activity_type == 3) {
			this.ai_activity_data = data;
			this.show_ai_activity_data = true;
		} else {
			this.ai_activity_data = {};
			this.show_ai_activity_data = false;
			this.selected_activities_list.push(JSON.parse(JSON.stringify(data)));
		}
    }

    // activityDetailsClosed(event) {
    //   this.show_activity_data = {};
    //   this.show_activity_details = false;
	//   this.activityDetailsUpdated.emit();
    // }
	check_sub_taks: any  = new Date().getTime();
	activityDetailsClosed(event) {
		this.selected_activities_list.splice(event.index, 1);

		if (this.selected_activities_list.length > 0) {
			if (this.selected_activities_list[this.selected_activities_list.length - 1].task_type  == "Main Task") {
				this.check_sub_taks = new Date().getTime();
			}
		}

		if (this.selected_activities_list.length == 0) {
			this.activityDetailsUpdated.emit();
		}
	}

	aiActivityDataUpdated(event) {
		this.ai_activity_data = {};
		this.show_ai_activity_data = false;
	}


	// subTasksSelected(data) {
	// 	this.show_activity_data = {};
    //   	this.show_activity_details = false;
	// 	setTimeout(() => {
	// 		this.showActivityDetails(data);
	// 	}, 100);
	// }

	subTasksSelected(data) {
		this.selected_activities_list.push(JSON.parse(JSON.stringify(data)));
	}

	@ViewChild('notificationModal') notificationModal: TemplateRef<any>;
	private notificationModalRef: MatDialogRef<TemplateRef<any>>;

	notification_data: any = {
		campaign_channel: "",
		campaign_content: "",
		campaign_date: new Date()
	};
	notification_data_errors: any = {
		campaign_channel: false,
		campaign_content: false,
		campaign_date: false
	};
	selected_notification_activity_data: any;

	openNotificationModal(type, content, activity_data) {
		this.notification_data.campaign_channel = JSON.parse(JSON.stringify(type));
		this.notification_data.campaign_content = JSON.parse(JSON.stringify(content));
		this.notification_data.campaign_date = new Date();

		this.selected_notification_activity_data = JSON.parse(JSON.stringify(activity_data));

		this.notificationModalRef = this.dialog.open(
			this.notificationModal, { disableClose: true }
		);
		this.notificationModalRef.afterClosed().subscribe((result) => {
			this.closeNotificationModal();
		});
	}

	closeNotificationModal() {
		this.notificationModalRef.close();
		this.resetNotificationData();
	}

	sendNotification() {
		if (this.notification_data.campaign_channel != "" && this.notification_data.campaign_channel != null) {
			this.notification_data_errors.campaign_channel = false;
		} else {
			this.notification_data_errors.campaign_channel = true;
		}

		if (this.notification_data.campaign_content != "" && this.notification_data.campaign_content != null) {
			this.notification_data_errors.campaign_content = false;
		} else {
			this.notification_data_errors.campaign_content = true;
		}

		if (this.notification_data.campaign_date != "" && this.notification_data.campaign_date != null) {
			this.notification_data_errors.campaign_date = false;
		} else {
			this.notification_data_errors.campaign_date = true;
		}

		if (
			this.notification_data_errors.campaign_channel == false &&
			this.notification_data_errors.campaign_content == false &&
			this.notification_data_errors.campaign_date == false
		) {
			let payload: any = {
				campaign_channel: this.notification_data.campaign_channel,
				campaign_content: this.notification_data.campaign_content,
				campaign_date: moment(this.notification_data.campaign_date).format(),
			};

			if (this.selected_notification_activity_data.source == 'csa') {
				payload.csa_id = this.selected_notification_activity_data.id;
			} else if (this.selected_notification_activity_data.source == 'lpa') {
				payload.lpa_id = this.selected_notification_activity_data.id;
			} else if (this.selected_notification_activity_data.source == 'ama') {
				payload.ama_id = this.selected_notification_activity_data.id;
			}

			this.commonService.postData("/campaignHistory/", payload).subscribe(
				(res: any) => {
					this.activityDetailsUpdated.emit();
					this.closeNotificationModal();
					this.commonService.showToast('success', "Campaign has been sent.");
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		}
	}

	resetNotificationData() {
		this.notification_data = {
			campaign_channel: "",
			campaign_content: "",
			campaign_date: new Date()
		};
		this.notification_data_errors = {
			campaign_channel: false,
			campaign_content: false,
			campaign_date: false
		};
		this.selected_notification_activity_data = {};
	}

	addManualTask() {
		const data = {
			id: null,
			parent_activity: null,
			activity_type: this.selected_activity_type,
			source: null,
		};
		this.showActivityDetails(data);
	}

	addManualSubTask(activity) {
		const data = {
			id: null,
			parent_activity: activity.id,
			activity_type: activity.activity_type,
			source: activity.source,
			user_type: activity.user_type,
			client: activity.client,
			prospect_id: activity.prospect_id,
			advisor: activity.advisor,
		};
		this.showActivityDetails(data);
	}

	newTasksSelected(event) {
		this.selected_activities_list.splice(event.index, 1, event.data);
	}

	// openEmail(email) {
	// 	// const email_data = JSON.parse(JSON.stringify(email));
	// 	// const parser = new DOMParser();
	// 	// const html = parser.parseFromString(email_data.email_body, 'text/html');
	// 	// window.open('mailto:' + email.email + '?subject=' + email.subject + '&body=' + encodeURIComponent(html.body.innerText), '_blank',);

	// 	const recipient = email.email;
	// 	const subject = email.subject;
	// 	const body = email.email_body;

	// 	const encodedSubject = encodeURIComponent(subject);
	// 	const encodedBody = encodeURIComponent(body);
	// 	const mailtoLink = `mailto:${recipient}?subject=${encodedSubject}&body=${encodedBody}`;
	// 	window.open(mailtoLink, '_blank');

	// }

	openEmail(email) {
		// const email_data = JSON.parse(JSON.stringify(email));
		// const parser = new DOMParser();
		// const html = parser.parseFromString(email_data.email_body, 'text/html');
		// window.open('mailto:' + email.email + '?subject=' + email.subject + '&body=' + encodeURIComponent(html.body.innerText), '_blank',);

		const recipient = email.email;
		const subject = email.subject;
		// const body = email.email_body;

		let body = email.email_body;
		const maxLength = 1250; // Example limit, adjust as needed
		body = this.convertHtmlToText(body)

		if (body.length > maxLength) {
			body = body.substring(0, maxLength) + '...';
		}

		const encodedSubject = encodeURIComponent(subject);
		const encodedBody = encodeURIComponent(body);
		const mailtoLink = `mailto:${recipient}?subject=${encodedSubject}&body=${encodedBody}`;
		window.open(mailtoLink, '_blank');

	}

	convertHtmlToText(htmlContent: string): string {
		const parser = new DOMParser();
		const doc = parser.parseFromString(htmlContent, 'text/html');

		// Extract text content and replace list items and newlines
		let textContent = doc.body.innerHTML;
		let firstParagraph = true;
		// textContent = textContent.replace(/<p class="MsoNormal"><span lang="EN-US">/g, match => {
		//   if (firstParagraph) {
		// 	firstParagraph = false;
		// 	return ''; // Replace the first occurrence with an empty string
		//   } else {
		// 	return '\n'; // Replace subsequent occurrences with a newline
		//   }
		// });

		textContent = textContent.replace(/<p[^>]*>(.*?)<\/p>/g, (match, content) => {
			content = content.trim();
			if (!content) {
				return ''; // Ignore empty paragraphs
			}

			if (firstParagraph) {
				firstParagraph = false;
				return content; // No new line for the first paragraph
			} else {
				return '\n' + content; // New line before subsequent paragraphs
			}
		});

		// Convert <li> to bullet points
		textContent = textContent.replace(/<li[^>]*>/g, '\n• ').replace(/<\/li>/g, '');
		textContent = textContent.replace(/<p[^>]*>|<br[^>]*>/g, '\n').replace(/<\/p>/g, '');

		// Remove all other HTML tags
		textContent = textContent.replace(/<[^>]+>/g, '');

		// Replace special characters for mailto link compatibility
		textContent = textContent.replace(/&#8217;/g, "'")   // Replace right single quote
								 .replace(/&amp;/g, "&")    // Replace ampersand
								 .replace(/&nbsp;/g, " ")   // Replace non-breaking spaces
								 .replace(/%/g, '%')      // URL encode %
								 .replace(/&/g, '&')      // URL encode &
								 .replace(/\n\n/g, '');    // Encode newline for mailto

		textContent = textContent
		.split('\n') // Split by newlines
		.map(line => line.replace(/\s+/g, ' ').trim()) // Process each line to replace multiple spaces with single space
		.join('\n');

		return textContent
	}

	public addIndividualManualTask() {
		const data = {
			id: null,
			parent_activity: null,
			activity_type: this.selected_activity_type,
			source: null,
		};
		this.showActivityDetails(data);
	}

	viewIndividualActivity(activity) {
		let role: any = "";
		if (this.user_details.role.role == 3) {
			role = '/executive';
		} else if (this.user_details.role.role == 4) {
			role = '/advisor-manager';
		} else if (this.user_details.role.role == 5) {
			role = '/advisor';
		} else if (this.user_details.role.role == 6) {
			role = '/afa';
		} else if (this.user_details.role.role == 7) {
			role = '/assistant';
		} else if (this.user_details.role.role == 8) {
			role = '/relationship-manager';
		} else if (this.user_details.role.role == 10) {
			role = '/leadership';
		} else if (this.user_details.role.role == 11) {
			// role = '/marketing-team';
			role = '/opportunity';
		} else if (this.user_details.role.role == 12) {
			role = '/wholesaler';
		} else if (this.user_details.role.role == 13) {
			role = '/lending-officer';
		} else if (this.user_details.role.role == 14) {
			role = '/insurance-agent';
		}

		this.router.navigate([role + '/activity-details/' + activity.source + "/" + activity.id], { state: { previousRoute: this.router.url } });

	}

	show_new_activity_details: boolean = false;
	new_activity_data: any;
	@Output() newactivityDetailsClosed = new EventEmitter<any>();
	addNewManualTask() {
		const data = {
			id: null,
			parent_activity: null,
			activity_type: this.selected_activity_type,
			source: null,
		};
		this.new_activity_data = JSON.parse(JSON.stringify(data));
		this.show_new_activity_details = true;
	}

	closeNewManualTask() {
		this.activityDetailsUpdated.emit();
		this.new_activity_data = {};
		this.show_new_activity_details = false;
	}

}
